import { render, staticRenderFns } from "./case.vue?vue&type=template&id=10d06911&scoped=true&"
import script from "./case.vue?vue&type=script&lang=js&"
export * from "./case.vue?vue&type=script&lang=js&"
import style0 from "./case.vue?vue&type=style&index=0&id=10d06911&prod&lang=scss&scoped=true&"
import style1 from "./case.vue?vue&type=style&index=1&id=10d06911&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d06911",
  null
  
)

export default component.exports